import { lazyLoad } from 'utils/loadable';

export const CoreStatsPage = lazyLoad(
  () => import('./index'),
  module => module.CoreStatsPage,
);
